import { render, staticRenderFns } from "./RoundConfigFormControlPoints.vue?vue&type=template&id=52415c59"
import script from "./RoundConfigFormControlPoints.vue?vue&type=script&lang=js"
export * from "./RoundConfigFormControlPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports